

export default function serializeStyle(style = {}) {
  let result = [];
  let key;
  for (key in style) {
    result.push(`${key}:${style[key]}`);
  }

  return result.join(';');
}



// WEBPACK FOOTER //
// ./src/components/Map/serializeStyle.js